import React, { memo, useMemo } from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Skeleton from "@mui/material/Skeleton";

const StoreSuppliesBreadcrumbSx = {
  display: "inline-block",
  verticalAlign: "bottom",
};

const StoreSuppliesBreadcrumb = ({ pogName = "" }) => {
  const { pogId } = useParams();

  const details = useMemo(() => {
    let navPoints = [];
    navPoints = [
      {
        label: pogId,
        href: "/store-supplies/pogs",
        isActive: true,
      },
    ];
    return pogId ? navPoints : [];
  }, [pogId]);

  const breadcrumbLoadingRenderer = useMemo(() => {
    return (
      <>
        <Skeleton
          variant="rounded"
          width={180}
          height={20}
          sx={StoreSuppliesBreadcrumbSx}
        />
      </>
    );
  }, []);

  return (
    <div role="presentation">
      {!!details.length && !!pogName ? (
        <Breadcrumbs aria-label="breadcrumb">
          {details.map((link) => (
            <Link
              key={link?.href}
              variant="caption"
              lineHeight="unset"
              underline="hover"
              fontWeight={600}
              color={link?.isActive ? "primary" : "inherit"}
              href={link?.href}
            >
              {link?.label} - {pogName}
            </Link>
          ))}
        </Breadcrumbs>
      ) : (
        breadcrumbLoadingRenderer
      )}
    </div>
  );
};

export default memo(StoreSuppliesBreadcrumb);
